module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAApElEQVQoU23Q2wnCQBCF4f9YiwRvoH0IoqBij4IGQSwighcsQWzChyMTNiFG922Zb2fOrGxPgaekG3+O7T6QyfYEmAM7Sfemtd0D1sBJUWjgfdX5C0lFCVt4C7yBTdlJKqJew4RHKUZcj5IuVaM2zFKmTsr8+IFpuwh+SKOXQC7pWo+2PQBWadw5xRgDiwrH9wyBeB2ZSvRnwTzgDHi1UQNH5+4H3iZPBkm/Fi4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/closeHover.png
// module id = cNRH
// module chunks = 2